$(document).ready(function () {
    $('.deleteuser-btn').on('click', function () {
        var id = $(this).attr('data-id');
        var name = $(this).attr('data-name');
        var acyr = $(this).attr('data-acyr');
        var sectionid = $(this).attr('data-sectionid');
        var userid = $(this).attr('data-userid');
        $('.student').text(name);
        $('.sectionnum').text(sectionid);
        $('input[type="hidden"][name="id"]').val(id);
        $('input[type="hidden"][name="acyr"]').val(acyr);
        $('input[type="hidden"][name="section_id"]').val(sectionid);
        $('input[type="hidden"][name="user_id"]').val(userid);
        $('#deletesectionusermodal').modal('show');
    });

    $('#addUserForm').submit(function () {
        $('button[type="submit"]').prop('disabled', true).html('Adding Student to Section ..... <i class="' + FontAwesome.prefix('solid', 'arrows-rotate', true) + '"></i>');
    });
    $('#deletesectionusermodal').submit(function () {
        $('#cancel-delete-sectionuser').prop('disabled', true);
        $('.close').hide();
        $('#delete-sectionuser').prop('disabled', true).html('Removing Student Details ..... <i class="' + FontAwesome.prefix('solid', 'arrows-rotate', true) + '"></i>');
    });
});
